import { render, staticRenderFns } from "./Text-Message.vue?vue&type=template&id=1784d0fa"
import script from "./Text-Message.vue?vue&type=script&lang=js"
export * from "./Text-Message.vue?vue&type=script&lang=js"
import style0 from "./Text-Message.vue?vue&type=style&index=0&id=1784d0fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports